import React from "react";
import Header from "../Components/Header/Header";
import { Outlet } from "react-router-dom";

const ReportLayout = () => {
  return (
    <div style={{ width: '100%', minHeight: '100vh', boxSizing: 'border-box' }}>
      <Header />
      <div style={{ width: '100%', boxSizing: 'border-box' }}>
        <Outlet />
      </div>
    </div>
  );
};

export default ReportLayout;
